import { Card, Form, Tabs, Upload } from "antd";
import TextArea from "antd/es/input/TextArea";
import styled from "styled-components";
import { color } from "../../resource";

export const CardStyled = styled(Card)`
  .ant-card-head {
    background-color: #eff2f9;
  }
  .ant-card-body {
    background-color: #fff;
  }
`;

export const ImageBox = styled.img`
  height: 136px;
  width: 137px;
  border-radius: 6px;
  object-fit: cover;
`;

export const ExpandButton = styled.button`
  border: none;
  background: transparent;
  color: #1890ff;
  cursor: pointer;
  padding: 0;
`;

export const TextAreaStyle = styled(TextArea)`
  .ant-input-suffix {
    position: absolute;
    left: 100px;
    right: auto;
    bottom: 0px;
    font-size: 13px;
    color: #999;
  }
`;

export const UploadBox = styled(Upload)`
  .ant-upload,
  .ant-upload-list-picture-card-container,
  .ant-upload-picture-card-wrapper,
  .ant-upload-list-picture-card .ant-upload-list-item {
    height: 148px;
    width: 148px};
  }
`;

export const UploadArea = styled.div`
  background: ${color.background1};
  border: 1px dashed ${color.Text3};
  border-radius: 6px;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
`;

export const UploadBoxReward = styled(Upload)`
  .ant-upload,
  .ant-upload-list-picture-card-container,
  .ant-upload-picture-card-wrapper,
  .ant-upload-list-picture-card .ant-upload-list-item {
    width: 140px};
    height: 200px;
  }
`;

export const UploadBoxBadge = styled(Upload)`
  .ant-upload,
  .ant-upload-list-picture-card-container,
  .ant-upload-picture-card-wrapper,
  .ant-upload-list-picture-card .ant-upload-list-item {
    height: 100px;
    width: 100px};
  }
`;
export const AchievementTabCardContainer = styled.div`
  border: 1px, solid, #e5eaee;
  background-color: #fff;
  border-radius: 12px;
  //padding: 28px 28px 28px 28px;
  height: 100%;
`;

export const CustomFormItem = styled(Form.Item)`
  .ant-form-item-explain-error {
    color: red;
    font-size: 13px;
    padding-top: 20px;
  }
`;
export const CustomFormItemRewaed = styled(Form.Item)`
  .ant-form-item-explain-error {
    color: red;
    font-size: 13px;
    padding-top: 10px;
  }
`;
